import Template from "../../component/Template.js";
import { useEffect, useRef } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "../../Assets/css/resptable.css";
import "../../Assets/css/responsiveptable.css";
import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Select from "react-select";
import { Input } from "@mui/material";

import $ from "jquery";

export default function SupplementaryNominalRoll() {
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }
  const tableRef = useRef(null);
  const collegename = localStorage.getItem("username");
  const [flag, setflag] = useState(false);
  const [tableData, setTableCountData] = useState([]);
  const [loading, setlodaing] = useState(false);
  const [examid, setExamIdData] = useState("");
  const [getexamData, setExamData] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);

  const { http } = Api();

  /* CUSTOM DATA TABLE BEGIN HERE */

  const [sortBy, setSortBy] = useState({ column: null, direction: "asc" });
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  /* CUSTOM DATA TABLE END HERE */

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(
          `College/getSupplementaryHallticketAtiveExam`
        );
        setExamData(response.data);
      } catch (error) {
        if (
          error.response.data.http_status === 401 &&
          error.response.data.status_code == "ERR9"
        ) {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        } else if (
          error.response.data.http_status === 429 &&
          error.response.data.status_code == "ERR33"
        ) {
          toast.error(error.response.data.message);
        } else if (
          error.response.data.http_status === 500 &&
          error.response.data.status_code == "ERR5"
        ) {
          toast.error("No active supplementary exam found");
        } else {
          toast.error("Something went wrong");
        }
      }
    };
    fetchExamData();
  }, []);

  const handlExamChange = async (selectedOption) => {
    const examId = selectedOption.value;
    setExamIdData(selectedOption.value);
    setSelectedExam(selectedOption);
    try {
      const response = await http.get("College/collegeSupplycourselist", {
        params: { examid: examId },
      });

      console.log("response==", response);
      setTableCountData(response.data);
    } catch (error) {
      if (
        error.response.data.http_status === 401 &&
        error.response.data.status_code == "ERR9"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (
        error.response.data.http_status === 429 &&
        error.response.data.status_code == "ERR33"
      ) {
        toast.error(error.response.data.message);
      } else if (
        error.response.data.http_status === 500 &&
        error.response.data.status_code == "ERR5"
      ) {
        toast.error("No active supplementary exam found");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleGenerateNominalRolePDF = async (
    examid,
    courseId,
    courseCode,
    courseType
  ) => {
    setlodaing(true);
    try {
      const response = await http.get(
        "/College/generateSupplyNominalRollcoursewise",
        {
          params: {
            examid: examid,
            course_id: courseId,
            college_course_type: courseType,
          },
          responseType: "blob",
        }
      );

      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          `${localStorage.getItem("username")}_${courseCode}_${courseType}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setlodaing(false);

        return Promise.resolve("PDF generated successfully");
      }
    } catch (error) {
      setlodaing(false);
      console.error("Error generating PDF:", error);
      return Promise.reject("Error generating PDF");
    }
  };

  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction:
        sortBy.column === column && sortBy.direction === "asc" ? "desc" : "asc",
    };
    setSortBy(newSortBy);
  };

  useEffect(() => {
    const filteredAndSortedData = [...tableData]
      .filter((tableDatas) => {
        return (
          tableDatas.course_code
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          tableDatas.course_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          tableDatas.college_course_type
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          tableDatas.total_students
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );
      })
      .sort((a, b) => {
        if (sortBy.direction === "asc") {
          return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
        } else {
          return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
        }
      });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(
      startIndex,
      startIndex + itemsPerPage
    );

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);
  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === "asc" ? (
        <i className="fa fa-sort-up ml-1" aria-hidden="true"></i>
      ) : (
        <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>
      );
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>;
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div
                    className="card-body d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Supplementary Course Wise Nominal Roll</h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card-body pdg">
                          <div className="table-responsive">
                            <div className="form theme-form tab-out-bod">
                              <div className="card-body custom-input">
                                <div className="row">
                                  <div className="col-md-12">
                                    <label>
                                      Exam<span className="errorclr">*</span>
                                    </label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      styles={customStyles}
                                      className="basic-select"
                                      classNamePrefix="select"
                                      options={getexamData.map((exam) => ({
                                        value: exam.examid,
                                        label: exam.examtitle,
                                      }))}
                                      onChange={handlExamChange}
                                      placeholder="Select a supplementary exam..."
                                    />
                                  </div>
                                </div>

                                <div className="txt-aln-jst m-10"></div>

                                <div className="row">
                                  <div className="col-md-6 wdt">
                                    <p>
                                      Showing {(currentPage - 1) * 50 + 1}
                                      {""}-
                                      {Math.min(
                                        (currentPage - 1) * 50 + 50,
                                        total_count
                                      )}{" "}
                                      of {total_count} entries
                                    </p>
                                  </div>
                                  <div className="col-md-6 wdt" align="right">
                                    <input
                                      type="text"
                                      value={searchQuery}
                                      onChange={handleSearchInputChange}
                                      placeholder="Search..."
                                      className="form-control"
                                    />
                                  </div>
                                </div>

                                <div className="table-responsive">
                                  <div
                                    class="table-container"
                                    style={{ overflowX: "unset" }}
                                  >
                                    <table
                                      className="display dataTable table-striped table-bordered ex-v-table "
                                      ref={tableRef}
                                    >
                                      <thead>
                                        <tr className="bg-primary">
                                          <th
                                            onClick={() =>
                                              handleSort("course_id")
                                            }
                                            scope="col"
                                            data-label="APAAR Id"
                                            width="8%"
                                          >
                                            Sl No &nbsp;
                                            {renderSortIcon("course_id")}{" "}
                                          </th>
                                          <th
                                            onClick={() =>
                                              handleSort("course_code")
                                            }
                                            scope="col"
                                            data-label="Course Code"
                                            width="14%"
                                          >
                                            Course Code &nbsp;
                                            {renderSortIcon("course_code")}{" "}
                                          </th>
                                          <th
                                            onClick={() =>
                                              handleSort("course_name")
                                            }
                                            scope="col"
                                            data-label="Course Name"
                                            width=""
                                          >
                                            Course Name &nbsp;
                                            {renderSortIcon("course_name")}{" "}
                                          </th>
                                          <th
                                            onClick={() =>
                                              handleSort("college_course_type")
                                            }
                                            scope="col"
                                            data-label="Course Type"
                                            width="14%"
                                          >
                                            Course Type &nbsp;
                                            {renderSortIcon(
                                              "college_course_type"
                                            )}{" "}
                                          </th>
                                          <th
                                            onClick={() =>
                                              handleSort("total_students")
                                            }
                                            scope="col"
                                            data-label="Total Student Count"
                                            width="18%"
                                          >
                                            Total Student Count &nbsp;
                                            {renderSortIcon(
                                              "total_students"
                                            )}{" "}
                                          </th>

                                          <th
                                            scope="col"
                                            data-label="Nominal Roll"
                                            width="17%"
                                          >
                                            Nominal Roll
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredAndSortedData.length > 0 ? (
                                          filteredAndSortedData.map(
                                            (item, index) => {
                                              const serialNumber =
                                                (currentPage - 1) * 50 +
                                                index +
                                                1;
                                              return (
                                                <tr key={item.discipline_id}>
                                                  <td data-label="Sl No."
                                                  style={{
                                                    textAlign: "center",
                                                  }}>
                                                    {serialNumber}
                                                  </td>
                                                  <td data-label="Course Code">
                                                    {item.course_code}
                                                  </td>
                                                  <td data-label="Course Name">
                                                    {item.course_name}
                                                  </td>
                                                  <td data-label="Course Type"
                                                  style={{
                                                    textAlign: "center",
                                                  }}>
                                                    {item.college_course_type}
                                                  </td>
                                                  <td
                                                    data-label="Total Student Count"
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {item.total_students}
                                                  </td>

                                                  <td data-label="Nominal Roll">
                                                    <div
                                                      className="txt-aln"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <i
                                                        className="fa fa-print icn-out-bod"
                                                        aria-hidden="true"
                                                        title="Nominal Roll"
                                                        onClick={() =>
                                                          handleGenerateNominalRolePDF(
                                                            examid,
                                                            item.course_id,
                                                            item.course_code,
                                                            item.college_course_type
                                                          )
                                                        }
                                                      ></i>
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="6"
                                              className="text-center"
                                            >
                                              No data found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  {totalPages > 1 && (
                                    <nav
                                      aria-label="..."
                                      style={{ cursor: "pointer" }}
                                    >
                                      <ul className="pagination justify-content-center">
                                        <li
                                          className={`page-item ${
                                            currentPage === 1 ? "disabled" : ""
                                          }`}
                                        >
                                          <span
                                            className="page-link pgn-clr"
                                            onClick={handlePreviousPage}
                                          >
                                            <i class="bi bi-arrow-left-circle-fill"></i>
                                          </span>
                                        </li>
                                        <li className={`page-item`}>
                                          <span
                                            className="page-link pgn-clr"
                                            onClick={() => handlePageChange(1)}
                                          >
                                            1
                                          </span>
                                        </li>
                                        {currentPage > 4 && (
                                          <li className="page-item">
                                            <span className="page-link pgn-clr">
                                              ...
                                            </span>
                                          </li>
                                        )}
                                        {[...Array(totalPages - 1).keys()]
                                          .slice(
                                            currentPage > 4
                                              ? currentPage - 3
                                              : 1,
                                            currentPage + 2
                                          )
                                          .map((pageNumber) => (
                                            <li
                                              key={pageNumber}
                                              className={`page-item ${
                                                pageNumber + 1 === currentPage
                                                  ? "act-clr"
                                                  : ""
                                              }`}
                                            >
                                              <span
                                                className="page-link pgn-clr"
                                                onClick={() =>
                                                  handlePageChange(
                                                    pageNumber + 1
                                                  )
                                                }
                                              >
                                                {pageNumber + 1}
                                              </span>
                                            </li>
                                          ))}
                                        {currentPage < totalPages - 3 && (
                                          <li className="page-item">
                                            <span className="page-link pgn-clr">
                                              ...
                                            </span>
                                          </li>
                                        )}

                                        <li className={`page-item`}>
                                          <span
                                            className="page-link pgn-clr"
                                            onClick={() =>
                                              handlePageChange(totalPages)
                                            }
                                          >
                                            {totalPages}
                                          </span>
                                        </li>

                                        <li
                                          className={`page-item ${
                                            currentPage === totalPages
                                              ? "disabled"
                                              : ""
                                          }`}
                                        >
                                          <span
                                            className="page-link pgn-clr"
                                            onClick={handleNextPage}
                                          >
                                            <i class="bi bi-arrow-right-circle-fill"></i>
                                          </span>
                                        </li>
                                      </ul>
                                    </nav>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
